import { render, staticRenderFns } from "./StudentMessageModal.vue?vue&type=template&id=1d1abf26&scoped=true"
import script from "./StudentMessageModal.vue?vue&type=script&lang=js"
export * from "./StudentMessageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1abf26",
  null
  
)

export default component.exports